import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex justify-end items-center p-6 pb-4"
};
const _hoisted_2 = {
  class: "px-6 pb-6"
};
const _hoisted_3 = {
  class: "flex flex-col items-center space-y-4"
};
const _hoisted_4 = {
  class: "text-sm text-gray-600 text-center"
};
import { ref, watch } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'SubscriptionCtaModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'subscribe-and-connect', 'schedule-call', 'close'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // Initialize composables - removed unused imports

    const isOpen = ref(props.modelValue);
    watch(() => props.modelValue, newValue => {
      isOpen.value = newValue;
    });
    watch(isOpen, newValue => {
      emit('update:modelValue', newValue);
    });
    const handleSubscribeAndConnect = () => {
      // Emit the event to parent (UpdateInvoiceTemplateModal) to handle navigation and plan selection
      emit('subscribe-and-connect');
      // Close this modal
      closeModal();
    };
    const handleScheduleCall = () => {
      // Open the sales demo page in a new tab
      window.open('https://www.leanlaw.co/get-a-demo/', '_blank');
      emit('schedule-call');
      // Close this modal
      closeModal();
    };
    const handleClose = () => {
      // If the modal is abandoned (closed without selection), simply close it.
      // Emit close event to tell parent to close all modals including UpdateInvoiceTemplateModal
      emit('close');
      closeModal();
    };
    const closeModal = () => {
      isOpen.value = false;
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_dialog, {
        modelValue: isOpen.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => isOpen.value = $event),
        persistent: "",
        "max-width": "700px",
        "data-cy": "subscription-cta-modal"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, {
          class: "rounded-lg overflow-hidden"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_v_icon, {
            onClick: handleClose,
            class: "text-gray-500 hover:text-gray-700 cursor-pointer text-2xl",
            "aria-label": "Close modal"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" mdi-close ", -1)]))]),
            _: 1
          })]), _createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = _createElementVNode("h2", {
            class: "text-2xl font-semibold text-gray-900 text-center"
          }, " Start Sending Real Invoices Today ", -1)), _cache[5] || (_cache[5] = _createElementVNode("p", {
            class: "text-md text-gray-700 leading-relaxed mb-8 text-center"
          }, " Connect QuickBooks Online and unlock LeanLaw's full invoicing workflow. Confirm your subscription now and get a same-week onboarding call with our QuickBooks specialist — so you can send your first invoice to a client right away. ", -1)), _createElementVNode("div", _hoisted_3, [_createVNode(LlSecondaryButton, {
            variant: "flat",
            color: "primary",
            class: "w-8/12",
            onBtnClick: handleSubscribeAndConnect,
            "data-cy": "subscribe-and-connect-btn"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" Pick Your Subscription & Get Started ", -1)]))]),
            _: 1
          }), _createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("span", null, "Not ready yet? ", -1)), _createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(handleScheduleCall, ["prevent"]),
            class: "text-gray-600 underline hover:text-gray-800 hover:no-underline",
            "data-cy": "schedule-call-btn"
          }, " Talk to a Product Specialist ")])])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};